import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=4aba0168&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
import style0 from "./loader.vue?vue&type=style&index=0&id=4aba0168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba0168",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Outputs/Images/PhotoEditor/components/loader.vue
// module id = 1396
// module chunks = 31